var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"localtime",attrs:{"data-gmt":_vm.time}},[_vm._v(" "+_vm._s(_vm.outputFormat)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }